import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  chevronIcon: {
    base: {
      display: 'inline-block',
      width: '20px',
      height: '20px',
      verticalAlign: 'top',
      transition: `transform ${theme.settings.transitions.regularFast}`,
      willChange: 'transform',

      '@media (prefers-reduced-motion: reduce)': {
        transition: 'none',
      },
    },

    'direction-up': {
      transform: 'rotate(180deg)',
    },

    'direction-left': {
      transform: 'rotate(90deg)',
    },

    'direction-right': {
      transform: 'rotate(-90deg)',
    },
  },
})
